/* istanbul ignore next */
if (typeof rcm != 'undefined') {
    // RCM is undefined in unit tests
    rcm.addAngularModule('app-ui-profile');
}
angular.module('app-ui-profile', ['pascalprecht.translate', 'pipe-rat-js', 'checkout', 'app-ui-country-rules']);
